/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { PraticaCittadinoSubmitForm } from '../model/pratica-cittadino-submit-form';
// @ts-ignore
import { PraticaSubmitResponseDTO } from '../model/pratica-submit-response-dto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    GestionePraticheSubmitPerContoDelCittadinoServiceInterface,
    SubmitPraticaPerCittadinoRequestParams
} from './gestione-pratiche-submit-per-conto-del-cittadino.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class GestionePraticheSubmitPerContoDelCittadinoService extends BaseService implements GestionePraticheSubmitPerContoDelCittadinoServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Sottomette una pratica per conto di un cittadino. Multipart: part \&#39;pratica\&#39; (JSON, stesso contratto del submit cittadino) + N part \&#39;allegato_&lt;target&gt;_&lt;chiave&gt;\&#39;. Il titolare e\&#39; risolto dal codice fiscale presente in anagrafica.form_data: se l\&#39;utente non esiste viene creato e riceve la mail di verifica (nessuna schermata dedicata). La pratica nasce in RICHIESTA_SOTTOMESSA senza OTP, con origine_richiesta&#x3D;OPERATORE_SUPPORTO e l\&#39;operatore inseritore tracciato. Audience SUPERADMIN | OP_COMUNE | OP_PRATICA con capability GESTIONE sul bando. Response: 201, 400 (CF/email mancanti nel form), 403/404 (bando fuori scope o non visibile; CF di un utente non-CITTADINO), 409 (CF gia\&#39; registrato, race), 422 (validazione form, allegati obbligatori mancanti, email gia\&#39; registrata).
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/pratiche/per-cittadino
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public submitPraticaPerCittadino(requestParameters: SubmitPraticaPerCittadinoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PraticaSubmitResponseDTO>;
    public submitPraticaPerCittadino(requestParameters: SubmitPraticaPerCittadinoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PraticaSubmitResponseDTO>>;
    public submitPraticaPerCittadino(requestParameters: SubmitPraticaPerCittadinoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PraticaSubmitResponseDTO>>;
    public submitPraticaPerCittadino(requestParameters: SubmitPraticaPerCittadinoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling submitPraticaPerCittadino.');
        }
        const allParts = requestParameters?.allParts;
        if (allParts === null || allParts === undefined) {
            throw new Error('Required parameter allParts was null or undefined when calling submitPraticaPerCittadino.');
        }
        const pratica = requestParameters?.pratica;
        if (pratica === null || pratica === undefined) {
            throw new Error('Required parameter pratica was null or undefined when calling submitPraticaPerCittadino.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'allParts',
            <any>allParts,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (pratica !== undefined) {
            localVarFormParams = localVarFormParams.append('pratica', localVarUseForm ? new Blob([JSON.stringify(pratica)], {type: 'application/json'}) : <any>pratica) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/pratiche/per-cittadino`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PraticaSubmitResponseDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
